import React, { useMemo, useRef } from 'react'

import { MainMenuFragmentFragment } from '../../../../graphql/gatsby'
import { useSanityRoleAndContextBasedContent } from '../../../../lib/sanity'
import { filterMenuEntriesToDisplay } from '../../../../utils/sanity/documents/menuEntry'
import { LinkRef } from '../../Link'
import MegaMenu from '../MegaMenu'
import * as Styled from './styled'

type MainMenuEntries = NonNullable<MainMenuFragmentFragment['mainMenu']>

export interface MainMenuEntryProps {
  menuEntry: NonNullable<MainMenuEntries[number]>
  isTempActive: boolean
}

export const MainMenuEntry: React.FC<MainMenuEntryProps> = React.memo(
  ({ menuEntry, isTempActive }) => {
    const { shouldDisplayContent } = useSanityRoleAndContextBasedContent()
    const shouldDisplay = useMemo(
      () => shouldDisplayContent(menuEntry),
      [menuEntry, shouldDisplayContent],
    )
    const hasSubMenuEntries = useMemo(
      () => filterMenuEntriesToDisplay(shouldDisplayContent)(menuEntry.childEntries).length > 0,
      [menuEntry.childEntries, shouldDisplayContent],
    )
    const linkRef = useRef<LinkRef>(null)

    if (!shouldDisplay) {
      return null
    }

    return (
      <>
        <Styled.MainMenuEntryLink link={menuEntry.link} ref={linkRef}>
          {menuEntry.name}
        </Styled.MainMenuEntryLink>
        {hasSubMenuEntries && (
          <MegaMenu mainMenuEntry={menuEntry} isVisible={isTempActive} menuEntryRef={linkRef} />
        )}
      </>
    )
  },
)

MainMenuEntry.displayName = 'MainMenuEntry'
